module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mario Vargas Llosa\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Mario Vargas Llosa")]), _vm._v(" is Peru's foremost author and the winner of the 2010 Nobel Prize in Literature. In 1994 he was awarded the Cervantes Prize, the Spanish-speaking world's most distinguished literary honor, and in 1995 he won the Jerusalem Prize. His many distinguished works include "), _c('I', [_vm._v("The Storyteller")]), _vm._v(", "), _c('I', [_vm._v("The Feast of the Goat")]), _vm._v(", "), _c('I', [_vm._v("Aunt Julia and the Scriptwriter")]), _vm._v(", "), _c('I', [_vm._v("Death in the Andes")]), _vm._v(", "), _c('I', [_vm._v("In Praise of the Stepmother")]), _vm._v(", "), _c('I', [_vm._v("The Bad Girl")]), _vm._v(", "), _c('I', [_vm._v("Conversation in the Cathedral")]), _vm._v(", "), _c('I', [_vm._v("The Way to Paradise")]), _vm._v(", and "), _c('I', [_vm._v("The War of the End of the World")]), _vm._v(". He lives in London.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4Zh2ZI/tc-custom/9781429922142.jpg?1731007755151",
      "alt": "This image is the cover for the book Captain Pantoja and the Special Service"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Captain Pantoja and the Special Service\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This delightful farce opens as the prim and proper Captain Pantoja learns he is to be sent to Peru's Amazon frontier on a secret mission for the army—to provide females for the amorous recruits. Side-splitting complications arise as world of Captain Pantoja's remarkable achievements start to spread.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Farrar, Straus, and Giroux\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0